import {
  FormControl,
  VStack,
  Text,
  Button,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { useSubscriptionPlanByPkQuery } from "../../../../lib/api/sdk";
import RegisterHeading from "../../Components/RegisterHeading";
import { INPUT_SPACING } from "../../RegisterPage";
import Prices from "./Prices";
import { useTranslations } from "next-intl";

const SubscriptionPrices = ({
  FormController,
  selectedPlan,
}: {
  FormController: any;
  selectedPlan: any;
}) => {
  const t = useTranslations("pages.register");
  const SubscriptionPlanReq = useSubscriptionPlanByPkQuery({
    variables: { id: selectedPlan },
  });

  return (
    <VStack
      spacing={INPUT_SPACING}
      w="full"
      align="start"
    >
      <RegisterHeading
        color="brandOrange.500"
        fontSize="4xl"
        mb="8"
      >
        {t("subscription")}
      </RegisterHeading>

      {!SubscriptionPlanReq.loading &&
        !SubscriptionPlanReq.data?.subscription_plan_by_pk ? (
        <VStack w="full" h="full" align="center">
          <Text textAlign={"center"}>
            {t("errorMessage2")}
          </Text>
          <Button onClick={() => SubscriptionPlanReq.refetch()}>
            {t("tryAgain")}
          </Button>
        </VStack>
      ) : (
        <FormControl isInvalid={!!FormController.formState.errors?.stripe_price_lookup_key}>
          <VStack w="full" spacing={5}>
            <Controller
              name="stripe_price_lookup_key"
              control={FormController.control}
              rules={{
                required: t("requiredSubscriptionPlanInputMessage"),
              }}
              render={({ field }) => {
                return (
                  <Prices
                    {...field}
                    data={SubscriptionPlanReq.data}
                    loading={SubscriptionPlanReq.loading}
                  />
                );
              }}
            />
            <FormErrorMessage>
              {
                FormController.formState.errors?.stripe_price_lookup_key
                  ?.message
              }
            </FormErrorMessage>
            <Text textAlign="center">
              {t("promoCode")}
            </Text>
          </VStack>
        </FormControl>
      )}
    </VStack>
  );
};

export default SubscriptionPrices;
